import axios from 'axios';

const RESOURCE_NAME = '/ecosystems';

export default {
    getEcosystems(data) {
        return axios.post(`${RESOURCE_NAME}/get-ecosystems`, data)
    },

    getDetails(id) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-details`)
    },

    getListForSearch(query) {
        return axios.get(`${RESOURCE_NAME}/list-for-search?query=${query}`)
    },

    getConnectedEcosystems() {
        return axios.get(`${RESOURCE_NAME}/get-connected-ecosystems`)
    },

    getTopListForSearch() {
        return axios.get(`${RESOURCE_NAME}/list-for-search-top`)
    },

    getCommonData(id) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-common-data`)
    },

    getNews(id) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-news`)
    },

    getActivities(id, sort) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-activities?sort=${sort}`)
    },

    getContacts(id, search) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-contacts?search=${search}`)
    },

    getNoteEdit(id, noteId) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-note-edit?note_id=${noteId}`)
    },

    saveNote(id, noteId, data) {
        return axios.post(`${RESOURCE_NAME}/` + id + `/save-note?note_id=${noteId}`, data)
    },

    getStartups(id, data) {
        return axios.post(`${RESOURCE_NAME}/` + id + `/get-startups`, data)
    },

    addConnection(data) {
        return axios.post(`${RESOURCE_NAME}/add-connection`, data)
    },

    invite(data) {
        return axios.post(`${RESOURCE_NAME}/invite`, data)
    },

    removeEcosystems(ecosystemIds) {
        return axios.post(`${RESOURCE_NAME}/remove-ecosystems`, {ecosystem_ids: ecosystemIds})
    },

    removeAllEcosystems() {
        return axios.post(`${RESOURCE_NAME}/remove-all-ecosystems`)
    },

    getPortfolioInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-portfolio-info?portfolio_id=${id}`)
    },

    getPortfolioStartups(id, data) {
        return axios.post(`${RESOURCE_NAME}/get-portfolio-startups?portfolio_id=${id}`, data)
    },

    getSharedPorfolios(id) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-shared-portfolios`)
    },

    getAccountInfo(id) {
        return axios.get(`${RESOURCE_NAME}/` + id + `/get-account-info`)
    },

    addErrorReport(id, data) {
        return axios.post(`${RESOURCE_NAME}/` + id + `/add-error-report`, data)
    },
}